
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";

export const IndexHeader = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  
  const userEmail = user?.email || t('dashboardDescription');
  
  return (
    <div className="text-center mb-8 sm:mb-12 px-2 animate-fade-in">
      <div className="inline-block mb-4">
        <div className="h-1.5 w-24 bg-primary rounded-full mb-1.5 mx-auto"></div>
        <div className="h-1.5 w-12 bg-primary rounded-full mx-auto"></div>
      </div>
      <h1 className="text-3xl sm:text-5xl font-bold tracking-tight text-center text-primary py-1">
        {t('campaignDashboard')}
      </h1>
      <p className="text-sm sm:text-lg text-muted-foreground max-w-2xl mx-auto mt-4 leading-relaxed text-center">
        {userEmail}
      </p>
    </div>
  );
};
